import(/* webpackMode: "eager" */ "/app/app/indicators/biblio/networks/page.jsx");
